<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'活动沙龙报名审核',goback:true},{name:'活动沙龙报名审核详情'}]" :title="'活动沙龙报名审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                     <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{dataInfos.createUserName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                     <div class="child" v-if="dataInfos.user">
                            <div class="name">账号类型：</div>
                            <div class="content">{{dataInfos.user.userTypeName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                     <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{dataInfos.createName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                     <div class="child" v-if="dataInfos.user">
                            <div class="name">邮箱：</div>
                            <div class="content">{{dataInfos.user.email||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                     <div class="child" v-if="dataInfos.user">
                            <div class="name">联系地址：</div>
                            <div class="content">{{dataInfos.user.contactAddress||'--'}}</div>
                        </div>
                  </el-col>
                  
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="提交信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{dataInfos.applicant||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{dataInfos.contactPhone||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{dataInfos.applyCompany||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">说明：</div>
							<div class="content">{{dataInfos.applyRemark||'--'}}</div>
                        </div>
                        <div class="attachment" v-if="dataInfos.fileList">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,index) in dataInfos.fileList" :key="index">
									<span>{{item.fileName}}</span>
									<i class="el-icon-download" @click="downLoad(item)"></i>
								</li>
                            </ul>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{dataInfos.createTime||'--'}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{dataInfos.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{dataInfos.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{dataInfos.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{dataInfos.checkExplanation}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            dataInfos:{
               user:{
                    userName:'',
                    userTypeName:'',
                    realName:'',
                    email:'',
                    contactAddress:'',
                },
                title:'',
                areaValue:'',
                guidelinesDetails:'',
                createTime:'',
                createUserName:'',
                modifyUserName:'',
                updateTime:'',
                fileList:[],
                checkStatusValue:'',
                checkExplanation:""
            },//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
      center: {}, //地图中心点
			maker: {}, //标记点
			zoom: 15, //缩放等级
        }
    },
    methods:{
        downLoad:function({filePath,fileName}){
    
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('/backstage/activity/salon/apply/details/'+this.id)
          if (code == 200) {            
              this.dataInfos = data 
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>